const $inject = ['$rootScope', '$q'];

const lbModalService = function lbModalService($rootScope, $q) {
  let service = {};

  let modal = {
    deferred: null,
    params: null
  };

  service.open = open;
  service.params = params;
  service.proceedTo = proceedTo;
  service.reject = reject;
  service.resolve = resolve;

  function open(type, options, params, pipeResponse) {
    let previousDeferred = modal.deferred;

    modal.deferred = $q.defer();
    modal.params = params;

    if (previousDeferred && pipeResponse ) {

      modal.deferred.promise.then(previousDeferred.resolve, previousDeferred.reject);

    } else if (previousDeferred) {
      previousDeferred.reject();
    }

    options = options || {};

    if(options.width) {
      options.width = options.width + 'px';
    }

    options.scroll = options.scroll || false;

    $rootScope.$emit('modals.open', type, options);

    return(modal.deferred.promise);
  }

  function params() {
    return(modal.params || {});
  }

  function proceedTo(type, params) {
    return(open(type, params, true));
  }

  function reject(reason) {
    if (!modal.deferred) {
      return;
    }

    modal.deferred.reject( reason );

    modal.deferred = modal.params = null;

    $rootScope.$emit('modals.close');
  }

  function resolve(response) {
    if (!modal.deferred) {
      return;
    }

    modal.deferred.resolve(response);

    modal.deferred = modal.params = null;

    $rootScope.$emit('modals.close');
  }

  return service;
};

lbModalService.$inject = $inject;

export default lbModalService;


// WEBPACK FOOTER //
// ./src/components/lbModal/lbModalService.js